import React from 'react';
import sanitizeHtml from 'sanitize-html';

import SystemMessage from './SystemMessage';

import { Link } from 'libs/router';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message.i18n.json'));

import type { Campaign } from 'types';

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['br']
};

type Props = {
  influencerActions: React.ReactNode,
  text: string,
  campaign: Campaign,
  subcampaignId: number,
  isBrand: boolean
};

class SystemChatMessageInvite extends SystemMessage<Props> {
  render(): React.ReactNode {
    const {
      influencerActions,
      text,
      campaign,
      subcampaignId,
      isBrand
    } = this.props;

    const subcampaignRoute = isBrand ?
      `/campaigns/${campaign.id}/subcampaigns/${subcampaignId}` :
      `/campaigns/${campaign.id}/details/${subcampaignId}`;

    const disclaimerType = isBrand ? 'brand' : 'creator';

    const disclaimer = __t(`system_message.expired_${disclaimerType}_disclaimer`);
    const disclaimerTooltip = __t(`system_message.expiration_disclaimer_${disclaimerType}_tooltip`);

    return (
      <React.Fragment>
        {this.renderIcon()}
        <div className="messages-system-message__container">
          <div
            className="messages-system-message__bubble"
            data-qa="messages-system-message-invite__bubble"
          >
            <div
              className="messages-system-message__heading"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(text, SANITIZE_HTML_CONFIG) }}
            />
            <div className="messages-system-message__brief">
              <Link
                to={subcampaignRoute}
                className="messages-system-message__link"
              >
                {__t('system_message.view_the_brief')}
              </Link>
            </div>
            {
              !isBrand &&
                this.renderActions(influencerActions)
            }
            {this.renderDisclaimer(disclaimer, disclaimerTooltip)}
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageInvite;
